/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USER_LIST_ADMIN = gql`
  query GetReferals($options: GetManyOptions, $filters: ReferalFilterInput) {
    getReferals(options: $options, filters: $filters) {
      count
      skip
      limit
      content {
        id
        user {
          vuid
          firstName
          lastName
          fullName
          email
          gender
          id
          accountStatus
          emailVerified
          suspended
        }
        createdAt
        updatedAt

        inviteNote
        presentation {
          id
          name
        }
        sections {
          id
          name
        }
        partition
        invitedBy {
          email
          firstName
          lastName
          fullName
        }
        sectionOptType
        box {
          paymentStats
          totalAmount
          totalAmountInUSD
          boxStatus
          amountPaid
          amountPaidInUSD
          costumeID
          note
        }
        inviteStatus
        expiresOn
        discountCode {
          discountCode
          status
        }
        inviteType
      }
    }
  }
`;

export const GET_USER_LIST = gql`
  query GetReferals($options: GetManyOptions, $filters: ReferalFilterInput) {
    getReferals(options: $options, filters: $filters) {
      count
      skip
      limit
      content {
        id
        user {
          vuid
        }
        createdAt
        updatedAt
        inviteNote
        presentation {
          id
          name
        }
        sections {
          id
          name
        }
        partition
        sectionOptType
        box {
          paymentStats
          totalAmount
          totalAmountInUSD
          boxStatus
          costumeID
          amountPaid
          amountPaidInUSD
          note
        }
        inviteStatus
        expiresOn
        discountCode {
          discountCode
          status
        }
        inviteType
      }
    }
  }
`;
